export const BONUS_CARD_CONSTS = {
    GET_BONUS_CARDS: "GET_BONUS_CARDS",
    DELETE_BONUS_CARD: "DELETE_BONUS_CARD",
};
